import {TARGETED_ACTION_TYPES} from '../../symbols';

export function hasActionHandlerForType(hostVariables, type) {
	return hostVariables[TARGETED_ACTION_TYPES].some(actionType => actionType === type);
}
